export const TOUR_ROW_MAP = {
  tourid: 'offer_id',
  countrycode: 'country_id',
  countryname: 'country_name',
  operatorcode: 'oper_id',
  operatorname: 'oper_name',
  hotelcode: 'hotel_id',
  hotelname: 'hotel_name',
  fulldesclink: 'hotel_link',
  hotelstars: 'star_id',
  regioncode: 'town_id',
  regionname: 'town_name',
  subregioncode: 'subregion_id',
  picturelink: 'hotel_image_src',
  flydate: 'dt1',
  adults: 'adult',
  child: 'child',
  mealcode: 'meal_id',
  meal: 'meal_name',
  room: 'room_name',
  placement: 'place_name',
};